const avalicao = {
  biopedancia: {
    percentual_gordura: "",
    percentual_musculo: "",
  },
  idade_metabolica: "",
  taxa_metabolica: "",
  indice_de_gordura_visceral: "",
  gordura_visceral: "",
  dobra_cutanea: {
    tricipal: "",
    subescapular: "",
    peitoral: "",
    biceps: "",
    suprailiaca: "",
    axilar_media: "",
    abdominal: "",
    coxa: "",
    panturrilha: "",
  },
  braco_esquerdo: "",
  braco_esquerdo_contraido: "",
  torax: "",
  quadril: "",
  coxa_esquerda: "",
  perna_esquerda: "",

  braco_direito: "",
  braco_direito_contraido: "",
  cintura: "",
  abdomen: "",
  coxa_direita: "",
  perna_direita: "",

  peso: "",
  altura: "",
  idade: "",
  user_id: "",
  images: [],
  motivacao: 0,
  sono: 0,
  frequencia_treino: 0,
};

const Objects = {
  avalicao,
};

export default Objects;
